import MessageServices from "@services/MessageServices";
import UtilServices from "@services/UtilServices";

//Configurações das colunas do grid.
const getFirstValidValue = (data, key) => {
    const validItem = data.find(item => item[key] !== null && item[key] !== '');
    return validItem ? validItem[key] : null;
};
const getColumnFormat = (key,hiddenFields = []) => {
    // Se a chave estiver na lista de ocultação, retorna a configuração com visible: false
    if (hiddenFields.includes(key)) {
        return {
            dataField: key,
            visible: false,// Oculta a coluna
        };
    }

    // Se conter valor ele aplica a mascará
    if (key.toLowerCase().includes("valor")) {
        return {
            dataField: key,
            // width: 'auto',
            caption: key.charAt(0).toUpperCase() + key.slice(1),
            dataType: 'number', // Define o tipo de dado como numérico
            format: '##0.00',
            alignment: 'left'
        };
    }
    // Se for uma data válida, retorna o tipo de dado como 'date'
    else if (key.toLowerCase().includes("data")) {
        return {
            dataField: key,
            // width: 'auto',
            caption: key.charAt(0).toUpperCase() + key.slice(1),
            dataType: 'date',
            format: 'dd/MM/yyyy HH:mm:ss'
        };
    //Se a chave for exatamente "cpf", aplica a máscara
    } else if (key.toLowerCase().includes("cpf")) {
        return {
            dataField: key,
            // width: 'auto',
            caption: key.charAt(0).toUpperCase() + key.slice(1),
            customizeText: (cell) => UtilServices.maskCPF(cell.value),
        };
    }
    //Se a chave for exatamente "cnpj", aplica a máscara
    else if (key.toLowerCase().includes("cnpj")) {
        return {
            dataField: key,
            // width: 'auto',
            caption: key.charAt(0).toUpperCase() + key.slice(1),
            customizeText: (cell) => UtilServices.maskCNPJ(cell.value),
        };
    }
    // Caso contrário, pode retornar um tipo genérico
    else {
        return {
            dataField: key,
            // width: 'auto',
            caption: key.charAt(0).toUpperCase() + key.slice(1),
        };
    }
};
const setTooltip = (cssClass,icon,title) => {
    const link = document.createElement("a");
    link.href = "#";
    link.className = `dx-link ${cssClass} dx-icon ${icon} dx-link-icon`;
    link.setAttribute("data-tooltip-id", "tooltip-001");
    link.setAttribute("data-tooltip-content", title);
    // link.setAttribute("title", title);
    return link
}

//Mapeamentos personalizados.
/*---CAD---*/
const getCAD_EmpresaConsultar = (data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal) => {
    // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
         {
            caption: 'Ações',
            type: 'buttons',
            fixedPosition: 'left',
            //fixed: true, //Estava quebrando o menuinterativo.
            width: 60,
            alignment: 'center',
            buttons: [
                //Editar
                {
                    // hint: 'Editar Empresa',
                    icon: 'fa-solid fa-pen-to-square',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(2,'Empresa','Editar'), // Desativa o botão
                    //  visible: function () {
                    //     return true;
                    //  },
                    onClick: function (e) {
                        dispatch({
                            type: "SET_EMPRESASELECIONADA",
                            payload: e.row.data, 
                          });
                        navigate("/CAD/Cadastrar");
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-pen-to-square','Editar Empresa'));
                    },     
                },
                //Inativar
                {
                    // hint: 'Inativar Empresa',
                    icon: 'fa-solid fa-xmark',
                    alignment: 'left',
                    cssClass: 'btn-inativar',
                    disabled: !handlePermissoes(2,'Empresa','Inativar'),
                    visible: function (e) {
                        //Se for inativa oculta
                        if(!e.row.data["Data Encerrada"])
                        {
                            return true; //Ativa
                        }
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Empresa',acao:'inativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-inativar','fa-solid fa-xmark','Inativar Empresa'));
                    },    

                },
                //Ativar
                {
                    // hint: 'Inativar Empresa',
                    icon: 'fa-solid fa-arrows-rotate',// 'fa-solid fa-rotate-reverse',
                    alignment: 'left',
                    cssClass: 'btn-ativar',
                    disabled: !handlePermissoes(2,'Empresa','Inativar'),
                    visible: function (e) {
                        //Se for inativa deve oculta
                        if(!e.row.data["Data Encerrada"])
                        {
                            return false; //Inativa
                        }
                        else{
                            return true //Ativa
                        }
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Empresa',acao:'ativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-ativar','fa-solid fa-arrows-rotate','Ativar Empresa'));
                    },    

                },
             ]
         },
        ...columns,
    ];
};
const getCAD_SocioConsultar = (data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal) => {
    // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key,['ID_Empresa_Socio','ID_Empresa']);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
         {
            caption: 'Ações',
            type: 'buttons',
            fixedPosition: 'left',
            //fixed: true, //Estava quebrando o menuinterativo.
            width: 60,
            alignment: 'center',
            buttons: [
                //Editar
                {
                    icon: 'fa-solid fa-pen-to-square',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(2,'Socio','Editar'), // Desativa o botão
                    //  visible: function () {
                    //     return true;
                    //  },
                    onClick: function (e) {
                        let data = {
                            ...e.row.data,
                        }
                        dispatch({
                            type: "SET_SOCIOSELECIONADO",
                            payload: data, 
                          });
                        navigate("/CAD/Cadastrar");
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-pen-to-square','Editar Socio'));
                    },     
                },
                //Inativar
                {
                    icon: 'fa-solid fa-xmark',
                    alignment: 'left',
                    cssClass: 'btn-inativar',
                    disabled: !handlePermissoes(2,'Socio','Inativar'),
                    visible: function (e) {
                        //Se for inativa oculta
                        if(!e.row.data["Data Encerramento"])
                        {
                            return true; //Ativa
                        }
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Socio',acao:'inativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-inativar','fa-solid fa-xmark','Inativar Sócio'));
                    },    

                },
                //Ativar
                {
                    // hint: 'Inativar Empresa',
                    icon: 'fa-solid fa-arrows-rotate',// 'fa-solid fa-rotate-reverse',
                    alignment: 'left',
                    cssClass: 'btn-ativar',
                    disabled: !handlePermissoes(2,'Socio','Inativar'),
                    visible: function (e) {
                        //Se for inativa deve oculta
                        if(!e.row.data["Data Encerramento"])
                        {
                            return false; //Inativa
                        }
                        else{
                            return true //Ativa
                        }
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Socio',acao:'ativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-ativar','fa-solid fa-arrows-rotate','Ativar Sócio'));
                    },    
                },
             ]
         },
        ...columns,
    ];
};
const getCAD_DadosSocioConsultar = (data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal,ccCheckBoxSocio) => {
    // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key,['ID_Empresa_Socio','ID_Empresa']);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
         {
            caption: 'Ações',
            type: 'buttons',
            fixedPosition: 'left',
            //fixed: true, //Estava quebrando o menuinterativo.
            width: 60,
            alignment: 'center',
            buttons: [
                //Editar
                {
                    icon: 'fa-solid fa-pen-to-square',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(2,'Socio','Editar'), // Desativa o botão
                     visible: function () {
                        if(ccCheckBoxSocio?.[0]?.["Data Encerramento"])
                        {
                            return false; //deixa invisivel
                        }
                        return true; //deixa visivel
                     },
                    onClick: function (e) {
                        let data = {
                            ...e.row.data,
                            cpf:ccCheckBoxSocio?.[0]?.CPF,
                        }
                        dispatch({
                            type: "SET_SOCIODADOSSELECIONADO",
                            payload: data, 
                          });
                        navigate("/CAD/Cadastrar");
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-pen-to-square','Editar Socio'));
                    },     
                },
                //Inativar
                {
                    icon: 'fa-solid fa-xmark',
                    alignment: 'left',
                    cssClass: 'btn-inativar',
                    disabled: !handlePermissoes(2,'Socio','Inativar'),
                    visible: function (e) {
                        if(e.row.data["Data Exclusão"] || ccCheckBoxSocio?.[0]?.["Data Encerramento"])
                        {
                            return false; //deixa invisivel
                        }
                        return true;
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Dadossocio',acao:'inativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-inativar','fa-solid fa-xmark','Inativar sócio para essa empresa'));
                    },    

                },
                //Ativar
                {
                    // hint: 'Inativar Empresa',
                    icon: 'fa-solid fa-arrows-rotate',// 'fa-solid fa-rotate-reverse',
                    alignment: 'left',
                    cssClass: 'btn-ativar',
                    disabled: !handlePermissoes(2,'Socio','Inativar'),
                    visible: function (e) {
                        if(e.row.data["Data Exclusão"] && !ccCheckBoxSocio?.[0]?.["Data Encerramento"])
                        {
                            return true; //deixa visivel
                        }
                        return false;
                    },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Dadossocio',acao:'ativar',dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-ativar','fa-solid fa-arrows-rotate','Ativar sócio para essa empresa'));
                    },    
                },
             ]
         },
        ...columns,
    ];
};
const getCAD_EnderecoConsultar = (data,handlePermissoes,dispatch,navigate,ccCheckBox,setDadosExcluir_AtivarInativar,setShowModal,tp) => {
    // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key,['ID_Empresa_Socio','ID_Empresa','ID_Endereco']);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
         {
            caption: 'Ações',
            type: 'buttons',
            fixedPosition: 'left',
            //fixed: true, //Estava quebrando o menuinterativo.
            width: 60,
            alignment: 'center',
            buttons: [
                 {
                    // hint: 'Editar Empresa',
                    icon: 'fa-solid fa-pen-to-square',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(2,'DadosEmpresa','Editar'), // Desativa o botão
                    //  visible: function () {
                    //     return true;
                    //  },
                    onClick: function (e) {
                        let data = {
                            ...e.row.data,
                            cnpj:ccCheckBox[0]?.CNPJ ?? ""
                        }
                        dispatch({
                            type: "SET_ENDERECOSELECIONADO",
                            payload: data, 
                          });
                        navigate("/CAD/Cadastrar");
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-pen-to-square','Editar Endereço'));
                    },     
                 },
                //Inativar
                {
                    icon: 'fa-solid fa-xmark',
                    alignment: 'left',
                    cssClass: 'btn-inativar',
                    disabled: !handlePermissoes(2,'Socio','Inativar'),
                    // visible: function (e) {
                    // },
                    onClick: function (e) {
                        setDadosExcluir_AtivarInativar(...[{key:'Endereco',acao:'excluir',tp:tp,dados:e.row.data}])
                        setShowModal(true);
                    },
                    //Ativar o tooltip
                    template: (container) => {
                       // Adiciona o link no container
                       container.appendChild(setTooltip('btn-inativar','fa-solid fa-xmark','Excluir Endereço'));
                    },    

                },
             ]
         },
        ...columns,
    ];
};
const getCAD_HistoricoConsultar = (data) => {
    // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key,['ID_Cliente','ID_Historico','ID_Empresa_Socio','ID_Empresa','ID_Endereco']);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
        ...columns,
    ];
};

/*---ECAC---*/
const getECAC_SituacaoFiscalAnalitica = (data,handlePermissoes,setShowModal,setBase64) => {
      // Verifica se os dados são válidos
    const columns = data && data.length > 0 && Object.keys(data[0]).length > 0
        ? Object.keys(data[0]).map(key => {
            // const firstValidValue = getFirstValidValue(data, key);
            return getColumnFormat(key,['Base64','ID_Empresa']);
        })
        : [
            // Default caso seja vazio.
            { dataField: 'id', caption: '' },
        ];

    return [
         {
            caption: 'Ações',
            type: 'buttons',
            fixedPosition: 'left',
            //fixed: true, //Estava quebrando o menuinterativo.
            width: 60,
            alignment: 'center',
            buttons: [
                //DownloadPDF
                {
                    icon: 'fa-solid fa-file-arrow-down',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(3,'SituacaoFiscal','Consultar'), // Desativa o botão
                    // visible: function () {
                    // },
                    onClick: function (e) {
                        if(e.row.data?.Base64)
                        {
                         UtilServices.base64inPDF(e.row.data?.Base64);
                        }else{
                            MessageServices.ShowWarning("Nenhum PDF disponível para download.");
                        }
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-file-arrow-down','Download PDF'));
                    },     
                },
                //Visualizar
                {
                    icon: 'fa-solid fa-eye',
                    alignment: 'left',
                    cssClass: 'btn-editar',
                    disabled: !handlePermissoes(3,'SituacaoFiscal','Consultar'), // Desativa o botão
                    // visible: function () {
                    // },
                    onClick: function (e) {
                        if(e.row.data?.Base64)
                        {
                         setShowModal(true);
                         setBase64(e.row.data?.Base64);
                        }else{
                            MessageServices.ShowWarning("Nenhum PDF disponível para vizualizar.");
                        }
                    },
                    //Ativar o tooltip
                    template: (container) => {
                        // Adiciona o link no container
                        container.appendChild(setTooltip('btn-editar','fa-solid fa-eye','Vizualizar PDF'));
                    },     
                },
             ]
         },
        ...columns,
    ];
};

export default {
    /*---CAD---*/
    getCAD_EmpresaConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal) {
        return getCAD_EmpresaConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal);
    },
    getCAD_SocioConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal) {
        return getCAD_SocioConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal);
    },
    getCAD_DadosSocioConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal,ccCheckBoxSocio) {
        return getCAD_DadosSocioConsultar(data,handlePermissoes,dispatch,navigate,setDadosExcluir_AtivarInativar,setShowModal,ccCheckBoxSocio);
    },
    getCAD_EnderecoConsultar(data,handlePermissoes,dispatch,navigate,ccCheckBox,setDadosExcluir_AtivarInativar,setShowModal,tp) {
        return getCAD_EnderecoConsultar(data,handlePermissoes,dispatch,navigate,ccCheckBox,setDadosExcluir_AtivarInativar,setShowModal,tp);
    },
    getCAD_HistoricoConsultar(data,handlePermissoes) {
        return getCAD_HistoricoConsultar(data,handlePermissoes);
    },
    /*---ECAC---*/
    getECAC_SituacaoFiscalAnalitica(data,handlePermissoes,setShowModal,setBase64) {
        return getECAC_SituacaoFiscalAnalitica(data,handlePermissoes,setShowModal,setBase64);
    },
};
